import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
`;
export const Wrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
`;
export const Title = styled.input`
  height: 34px;
  width: 600px;
  padding: 5px;
`;
export const Label = styled.label`
  margin-right: 20px;
`;
export const ThumbnailImage = styled.input``;
export const InputGroup = styled.div`
  margin-top: 20px;
`;
export const ImageCover = styled.input``;
export const Duration = styled.input`
  height: 34px;
  padding: 5px;
`;
export const Category = styled.input`
  height: 34px;

  padding: 5px;
`;
export const Button = styled.button`
  ouline: none;
  border: none;
  background: black;
  color: white;
  height: 30px;
  width: 60px;
`;

export const Toast = styled.div`
  color: red;
`;
